import React, { useEffect, useState } from 'react';
import { ScaleLoader } from 'react-spinners';
import { spinnerDelay } from '../helpers/constants';

export default function Spinner(props: Props) {
	const [waiting, setWaiting] = useState<boolean>(!props.noDelay);
	
	useEffect(() => {
		if (waiting) {
			const timeout = setTimeout(() => {
				setWaiting(false);
			}, spinnerDelay);
			
			return () => clearTimeout(timeout);
		}
	}, []);
	
	if (waiting)
		return null;
	
	return (
		<React.Fragment>
			<div className="text-center">
				<ScaleLoader color="#007bff" loading={true} height={35} width={4} radius={2} margin={2} />
			</div>
		</React.Fragment>
	);
}

interface Props {
    noDelay?: boolean;
}